import { useEffect, useState } from "react";
import usePlacesAutocomplete from "use-places-autocomplete";
import { createSearchParams, useNavigate } from "react-router-dom";
import "@reach/combobox/styles.css";
import { InputBox } from "../../common/components/InputBox";
import { LOGO, PROPERTY_VIDEO, defaultBounds } from "../../common/constants";
import styles from "./Homepage.module.scss";

const Homepage = () => {
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();
  const {
    ready,
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      bounds: defaultBounds,
      componentRestrictions: { country: ["in"] },
    },
    debounce: 300,
    cacheKey: "real_estate_agency",
    cache: 24 * 60 * 60,
  });

  const handleSelect = (address: string): any => {
    setValue(address, false);
    clearSuggestions();
  };

  const onHandleChange = (value: string) => {
    setValue(value);
  };

  const onSearchClick = (value: string) => {
    navigate({
      pathname: "/chat",
      search: createSearchParams({
        query: value,
      }).toString(),
    });
  };

  const onSubmit = (value: string) => {
    navigate({
      pathname: "/chat",
      search: createSearchParams({
        query: value,
      }).toString(),
    });
  };

  useEffect(() => {
    if (!localStorage.getItem("homeloader")) {
      setTimeout(() => {
        localStorage.setItem("homeloader", "true");
        setLoader(false);
      }, 3000);
    } else {
      setLoader(false);
    }
  }, []);

  return (
    <main className={styles.container}>
      <section className={styles.absoluteCenter}>
        <img src={LOGO} className={styles.logo} />
        <InputBox
          onSearchClick={onSearchClick}
          placeholder={"Search for locality, landmark project, or builder"}
          handleChange={onHandleChange}
          onSubmit={onSubmit}
          disabled={!ready}
          inputValue={value}
        />
        {status === "OK" && data.length > 0 && (
          <article className={`${styles.list} `}>
            {data.map(({ place_id, description }) => (
              <p
                key={place_id}
                className={styles.listItem}
                onClick={() => handleSelect(description)}
              >
                {description}
              </p>
            ))}
          </article>
        )}
      </section>
      <section>
        <video
          src={PROPERTY_VIDEO}
          className={styles.video}
          autoPlay
          loop
          muted
        />
      </section>
      {loader && (
        <div className={styles.loaderAbsoluteStyles}>
          <div>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/communityhouse-b50a0.appspot.com/o/loader.gif?alt=media"
              width={100}
            />
          </div>
        </div>
      )}
    </main>
  );
};

export default Homepage;
